import axios from 'axios';
import router from '../router/router'
import {
  Message,
} from 'element-ui';
// import LocalStorage from '@/utils/store'
import qs from 'qs';
import { getToken, removeToken } from '@/utils/auth';
// import router from '../router'
import store from '../store/store';

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL, // api的base_url只有在桌面应用的时候才打开
  timeout: 1500000, // 请求超时时间
  paramsSerializer(params) {
    return qs.stringify(params, {
      arrayFormat: 'repeat',
    });
  },
});
let configBase = null;
// 设置全局post请求content-type
service.defaults.headers.post['Content-Type'] = 'application/json';

// request拦截器
service.interceptors.request.use((config) => {
  if (store.state.token) {
    // // 用户登录信息，跟随header传递到接口
    config.headers.common.token = (`${store.state.token}`);
  }
  configBase = config;
  return config;
}, (error) => {
  Promise.reject(error);
});

// respone拦截器
service.interceptors.response.use(
  (response) => {
    const res = response.data;
    // console.log(res, '++++++++++=');
    if (res.msg && res.status == '10000') {
      // return res.result;
      return res;
    } if (res.msg && res.status == '401') {
      // store.commit('setToken', '');
      // store.commit('setDialogVisible', true);
      store.commit('setLoading', false);
      // router.replace('/login')
      Message({
        message: res.content,
        type: 'error',
        duration: 3 * 1000,
      });
      return Promise.reject(res);
    }
    if (res.msg && res.status == '10001') {
      // store.commit('setToken', '');
      // store.commit('setUserInfo', '');
      // store.commit('setLoginFlag', false);
      // store.commit('setIsAdmin', false);
      // store.commit('setIsRemAdmin', false);
      // store.commit('setIsUserAdmin', false);
      // router.replace('/login')
      // window.localStorage.clear();
    }
    if (res.msg && res.status == '10006') {
      // store.commit('setToken', '');
      // store.commit('setUserInfo', '');
      // store.commit('setLoginFlag', false);
      // store.commit('setIsAdmin', false);
      // store.commit('setIsRemAdmin', false);
      // store.commit('setIsUserAdmin', false);
      // router.replace('/login')
      // window.localStorage.clear();
      return Promise.reject(res);
    }
    if (res.msg && res.status == '20002') {
      // store.commit('setToken', '');
      // store.commit('setDialogVisible', true);
      // store.commit('setLoading', false);
      // router.replace('/login')
      Message({
        message: res.msg,
        type: 'error',
        duration: 3 * 1000,
      });
      return Promise.reject(res);
    }
    // Message({
    //   message: res.msg,
    //   type: 'error',
    //   duration: 3 * 1000,
    // });
    // return Promise.reject(res);

    // if (res.code && res.code == 200) {
    //   return res.content
    // } else if (res.code && res.code == 401){
    //   store.commit('setToken','')
    //   store.commit('setDialogVisible',true)
    //   store.commit('setLoading',false)
    //   Message({
    //     message: res.content,
    //     type: 'error',
    //     duration: 3 * 1000
    //   })
    //   return Promise.reject(res)
    // } else {
    //   Message({
    //     message: res.content,
    //     type: 'error',
    //     duration: 3 * 1000
    //   })
    //   return Promise.reject(res)
    // }
  },
  (error) => {
    console.log(error);
    Message({
      message: error.msg,
      type: 'error',
      duration: 3 * 1000,
    });
    // removeToken();
    // router.replace('/login')
    return Promise.reject(error);
  },
);

export default service;
